module.exports = __webpack_public_path__ + "img/icon_sb_shipping_boutique_16x16.8fc3d59.svg";